import axios from 'axios';
import { API_URL } from './config';

const api = axios.create({
    baseURL: API_URL,
    timeout: 0, // 0 desativa o timeout do Axios, obrigando-o a esperar infinitamente a resposta do servidor
    withCredentials: true // Ativa envio e recebimento de Cookies em CORS
});

// Interceptor para adicionar o Token legado por garantia (Opcional, mas mantido pra evitar quebrar coisas, preferencialmente cookie)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('admin_token'); // TODO: Pode ser removido futuramente
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Interceptor para tratar erros globalmente
api.interceptors.response.use(
    (response) => response, // Se a resposta for OK, apenas retorna ela
    (error) => {
        // Se for um erro de rede (servidor caiu)
        if (!error.response) {
            console.log("⚠️ Erro de rede detectado. O servidor pode estar offline.");
            return Promise.reject(new Error("Servidor Offline"));
        }

        // Se o token for inválido ou expirou (401), desloga o usuário
        if (error.response.status === 401 && !error.config.url.includes('/auth/')) {
            localStorage.removeItem('is_logged_in');
            localStorage.removeItem('admin_token'); // Limpeza por segurança
            window.location.reload(); // Recarrega para cair na tela de login
        }

        return Promise.reject(error);
    }
);

export default api;